import React from 'react';
    import { motion } from 'framer-motion';

    const Meetings = () => {
      const externalLink = "https://members.sellersanonymous.org/";
      const expectations = [
        'Bring a real deal you\'re wrestling with',
        'Hear how others apply buyer-centric principles in tough environments',
        'Leave with a clearer conscience and a clearer next step'
      ];

      return (
        <section id="meetings" className="py-20 bg-white">
          <div className="container">
            <div className="max-w-4xl mx-auto">
              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                whileInView={{ opacity: 1, y: 0 }} 
                viewport={{ once: true }} 
                transition={{ duration: 0.6 }} 
                className="text-center mb-12"
              >
                <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-6">
                  Join a Sellers Anonymous Meeting
                </h2>
                <p className="text-xl text-slate-600 leading-relaxed max-w-2xl mx-auto">
                  Meetings are small, collaborative, and confidential (recording not permitted). 
                  <br />
                  <span className="font-medium">No pitching. No roleplay theatre. Just real sellers talking honestly about real work.</span>
                </p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                whileInView={{ opacity: 1, y: 0 }} 
                viewport={{ once: true }} 
                transition={{ duration: 0.6, delay: 0.2 }} 
                className="bg-gradient-to-br from-slate-50 to-cyan-50 rounded-2xl p-8 mb-12"
              >
                <h3 className="text-xl font-semibold text-slate-800 mb-6 text-center">
                  What to expect:
                </h3>
                <p className="text-slate-600 mb-6 text-center">In a typical session, you can:</p>
                <div className="space-y-4 max-w-xl mx-auto">
                  {expectations.map((expectation, index) => (
                    <motion.div 
                      key={index} 
                      initial={{ opacity: 0, x: -20 }} 
                      whileInView={{ opacity: 1, x: 0 }} 
                      viewport={{ once: true }} 
                      transition={{ delay: index * 0.1 }} 
                      className="flex items-start space-x-4"
                    >
                      <div className="w-8 h-8 bg-white rounded-lg shadow-sm flex items-center justify-center flex-shrink-0 mt-0.5">
                        <div className="w-3 h-3 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-full"></div>
                      </div>
                      <span className="text-slate-700">{expectation}</span>
                    </motion.div>
                  ))}
                </div>
                
                <div className="text-center mt-12">
                  <a 
                    href={externalLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-cyan-600 hover:bg-cyan-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-200 hover:shadow-xl hover:scale-105"
                  >
                    Join a Meeting
                  </a>
                </div>
              </motion.div>
            </div>
          </div>
        </section>
      );
    };

    export default Meetings;